const BASE_URL = "https://codex.mrc.ai/api";

export async function getCodeList(tableId) {
  const response = await fetch(`${BASE_URL}/codelists/${tableId}`);
  if (!response.ok) throw new Error("Failed to fetch CodeList");
  return await response.json();
}

export async function getCode(version, codelist, longCode) {
  const url = `${BASE_URL}/${version}/codelists/${codelist}/codes/${longCode}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch Code");
  return await response.json();
}
